<template>
  <div
    class="waf-matchtips fg-widget"
    v-if="has_match_page_store && has_store_data"
  >
    <div v-if="current_match">
      <top-tabs :current_match="current_match" />
      <div class="waf-component roi-component waf-match-info">
        <div class="content-wrap" v-if="has_store_data">
          <div class="waf-body" v-show="!no_matches_active">
            <div class="tab-content lazy-bg">
              <info-feed v-if="hasMatchInfoData" />
            </div>
          </div>
          <div class="fg-preloader-wrap" v-if="is_loading">
            <div class="fg-preloader"></div>
          </div>
        </div>
      </div>
      <contest-widget
        :current_match="current_match"
        :showInLHS="false"
        storeName="customTipsWidget"
      />
    </div>
  </div>
</template>
<script>
import { getMatch } from "../../assets/js/common";
import MatchDetailStore from "../../store/modules/matchDetails/matchDetailsStore";
import customTipsWidgetModule from "../../store/modules/ndtv/custom-tips-widget";
import TopTabs from "./TopTabs";
import InfoFeed from "./InfoFeed";
import ContestWidget from "./ContestWidget";

export default {
  components: {
    InfoFeed,
    TopTabs,
    ContestWidget,
  },
  data() {
    return {
      componentPromises: null,
    };
  },

  computed: {
    has_match_page_store() {
      return !!(this.$store.state && this.$store.state.match_detail_store);
    },
    slug: {
      get: function () {
        return this.$store.state.match_detail_store.slug;
      },
      set: function (new_slug) {
        this.$store.state.match_detail_store.slug = new_slug;
      },
    },
    translations() {
      return this.$store.state.translations;
    },
    is_mobile_view() {
      let is_mobile = this.$route && this.$route.query && this.$route.query.is_mobile == 1; // when server isMobile detection fail and query having is_mobile
      return this.$store.state.ismobile || is_mobile;
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    no_matches_active() {
      return this.$store.state.match_detail_store.no_matches_active;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug);
    },
    /**shared state */
    has_store_data() {
      return !!(this.$store.state && this.$store.state.customTipsWidget);
    },
    is_loading() {
      return this.$store.state.customTipsWidget.is_loading;
    },
    hasMatchInfoData() {
      return this.$store.state.customTipsWidget.hasMatchInfoData;
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    await this.$store.registerModule("match_detail_store", MatchDetailStore);
    await this.$store.registerModule("customTipsWidget", customTipsWidgetModule);
    return await Promise.all([
      this.$store.dispatch("match_detail_store/fetchMatchData"),
    ]).then(() => {
      return this.$store.dispatch("customTipsWidget/fetchFeed", "customTipsWidget");
    });
  },
  mounted() {
    let hasStore = this.has_store_data;
    console.info(">>>> widget loaded", hasStore);
    this.registerCustomTipsWidgetModule();
    this.callApis(hasStore);
  },
  methods: {
    registerCustomTipsWidgetModule() {
      let hasMatchDetailStore = this.$store.hasModule("match_detail_store");
      if (!hasMatchDetailStore) {
        this.$store.registerModule("match_detail_store", MatchDetailStore, {
          preserveState: this.has_match_page_store,
        });
      }

      let customTipsWidget = this.$store.hasModule("customTipsWidget");
      if (!customTipsWidget) {
        this.$store.registerModule("customTipsWidget", customTipsWidgetModule, {
          preserveState: this.has_store_data,
        });
      }
    },
    callApis(hasStore) {
      this.initApis(hasStore);
    },
    async initApis(hasStore) {
      if (hasStore) {
        return await this.$store.dispatch("customTipsWidget/fetchMiniROIdata");
      } else {
        // this block run on local environment and other envs if store data is missing
        await Promise.all([
          this.$store.dispatch("match_detail_store/fetchMatchData"),
        ]);
        return await Promise.all([
          this.$store.dispatch("customTipsWidget/fetchMiniROIdata"),
          this.$store.dispatch(
            "customTipsWidget/fetchFeed",
            "customTipsWidget"
          ),
        ]);
      }
    },
  },
  beforeDestroy() {
    if (this.componentPromises) {
      this.componentPromises.then(() => {
        this.$store.unregisterModule("customTipsWidget");
        this.$store.unregisterModule("match_detail_store");
      });
    } else {
      this.$store.unregisterModule("customTipsWidget");
      this.$store.unregisterModule("match_detail_store");
    }
  },
};
</script>
